import { render } from "./EditDependent.vue?vue&type=template&id=fcea59b0"
import script from "./EditDependent.vue?vue&type=script&lang=js"
export * from "./EditDependent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__